import { Radio } from 'antd'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React, { useState } from 'react'

interface SecurityModalProps {
  openModal: boolean
  closeModal: React.Dispatch<React.SetStateAction<boolean>>
  riskLevel: 'low' | 'medium' | 'high'
  setRiskLevel: (state: 'low' | 'medium' | 'high') => void
}

const SecurityModal: React.FC<SecurityModalProps> = ({
  openModal,
  closeModal,
  riskLevel,
  setRiskLevel,
}) => {
  const [selectedOption, setSelectedOption] = useState<
    'low' | 'medium' | 'high'
  >('low')

  const handleSubmit = () => {
    setRiskLevel(selectedOption)
    closeModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={closeModal}
        title="Security"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Save"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <div>
          <Radio.Group
            className="security flex flex-col gap-20px"
            defaultValue={riskLevel}
            onChange={e => setSelectedOption(e.target.value)}
          >
            <Radio value={'low'} className="mr-40 radio">
              <div>
                <h3 className="text-15 w-500">Low risk</h3>
                <p className="text-gray">
                  Self check-in for family events + auto check-out{' '}
                </p>
              </div>
            </Radio>
            <Radio value={'medium'} className="mr-40 radio">
              <div>
                <h3 className="text-15 w-500">Medium risk</h3>
                <p className="text-gray">Check-in + Check-out or signature</p>
              </div>
            </Radio>
            <Radio value={'high'} className="mr-40 radio">
              <div>
                <h3 className="text-15 w-500">High risk</h3>
                <p className="text-gray">Check-in + Check-out or signature</p>
              </div>
            </Radio>
          </Radio.Group>
        </div>
      </CustomModal>
    </>
  )
}

export default SecurityModal
